<template>
  <div class="calendar">
    <div class="container">
      <div class="c-header">
        <ol>
          <li><el-date-picker v-model="date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" @change="changeDate"></el-date-picker></li>
          <li><el-time-picker v-model="time" value-format="HH:mm:ss" :editable="false" placeholder="选择默认时间" @change="changeTime" ></el-time-picker></li>
        </ol>
        <div style="display:flex">
          <div class="button"><router-link to="/">返回首页</router-link></div>
        </div>
      </div>
      <div class="name-box">
        <div class="almanac-table" v-html="tableData"></div>
        <ul class="table-li">
         <li><label>胎元：</label><span>{{taiYuan}}（{{taiYuan2}}）</span></li>
         <li><label>胎息：</label><span>{{taiXi}}（{{taiXi2}}）</span></li>
         <li><label>命宫：</label><span>{{mingGong}}（{{mingGong2}}）</span></li>
         <li><label>身宫：</label><span>{{shenGong}}（{{shenGong2}}）</span></li>
         <li class="wd100"><label>日空：</label><span>{{dayXunKong}}</span></li>
         <li>{{quewx}}</li>
        </ul>
      </div>
    </div>
    <div class="container">
      <div class="c-header">
        <ol>
          <li><el-input v-model="name" placeholder="请输入姓氏（不支持复姓）" maxlength="1"></el-input></li>
          <li><el-button type="primary" @click="getListData">生成</el-button></li>
          <li>{{wx}}</li>
        </ol>
      </div>
      <div v-if="bodyVisible">
      <div class="pd20" v-show="nameDataVisible">
        <h3>名字参考</h3>
        <div class="namedata">
          <dl>
            <dt><span>名字</span></dt>
            <dd class="wx">五行</dd>
            <dd>简介</dd>
          </dl>
          <dl v-for="(item, index) in createNameData" :key="index">
            <dt><span>{{item.name}}</span></dt>
            <dd class="wx">{{item.wx}}</dd>
            <dd :title="item.desc">{{item.desc}}</dd>
          </dl>
        </div>
      </div>
      <div class="body-box" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-html="htmlFormat(body)" v-if="nameVisible"></div>
      </div>
      <div v-else>
        <p>当前姓氏暂未收录</p>
      </div>
    </div>
    <footerCon></footerCon>
  </div>
</template>
<script>
import footerCon from "@/components/footer";
import {Solar} from 'lunar-typescript';
import surname from '@/utils/surname'
import nameData from "@/utils/nameData";
export default {
  components: {
    footerCon
  },
  data() {
    return {
      date: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      time: null,
      tableData:'',
      taiYuan:'',
      taiYuan2:'',
      taiXi:'',
      taiXi2:'',
      mingGong:'',
      mingGong2:'',
      shenGong:'',
      shenGong2:'',
      dayXunKong:'',
      wuxing:'',
      quewx:'',
      main:{
        a:'',
        a1:'',
        a2:'',
        b:'',
        c:'',
        s1:'',
        s2:'',
        s3:'',
        s4:''
      },
      name:'',
      nameValue:'',
      apiUrl:window.g.apiUrl,
      body:'',
      wx:'',
      nameVisible:false,
      nameDataArr:nameData.data,
      createNameData:[],
      nameDataVisible:false,
      bodyVisible:true,
      loading:false
    };
  },
  mounted(){
    this.initTime()
    this.getLastPathSegment()
    this.getTableData()
  },
  methods: {
    initTime(){
      let date = new Date()
      this.time = this.formatTime(date.getHours(), date.getMinutes(), date.getSeconds());
    },
    formatTime(hours, minutes, seconds) {
      return `${this.padStart(hours)}:${this.padStart(minutes)}:${this.padStart(seconds)}`;
    },
    changeDate(val){
      this.date = val
      this.getTableData()
    },
    padStart(value) {
      return value.toString().padStart(2, '0');
    },
    changeTime(val){
      this.time = val
      this.getTableData()
    },
    getLastPathSegment() {
      const url = window.location.href;
      const segments = url.split('/').filter(segment => segment);
      this.nameValue = segments[segments.length - 1];
      const title = surname.data.filter(items => items.py2 === this.nameValue)
      if(title.length > 0){
        this.name = title[0].name
        document.title = this.name + '姓八字取名技巧,' +  this.name + '姓取名参考,' + this.name + '姓历史来源,'  + this.name + '姓家族名人,' + this.name + '姓地望分布-' + window.g.title
        document.querySelector('meta[name="keywords"]').setAttribute('content', this.name + '姓八字取名技巧,' +  this.name + '姓名字参考,' + this.name + '姓历史来源,'  + this.name + '姓家族名人,' + this.name + '姓地望分布');
        document.querySelector('meta[name="description"]').setAttribute('content', '中华老黄历网为大家提供' + this.name + '姓八字取名技巧，其中还包含' + this.name + '姓历史来源，'  + this.name + '姓家族名人，' + this.name + '姓地望分布等相关信息！')
        this.getListData()
      }
    },
    //生辰八字
    getTableData(){
      let year = Number( this.date.split('-')[0])
      let month =  Number(this.date.split('-')[1])
      let day =  Number(this.date.split('-')[2])
      let hour = Number(this.time.split(':')[0])
      let minute = Number(this.time.split(':')[1])
      let dateTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':0'
      this.year = year.toString();
      this.month = month + '月';
      this.day = day;
      const solar = Solar.fromYmdHms(year,month,day,hour,minute,0);
      const lunar = solar.getLunar();
      const bazi = lunar.getEightChar();
      this.tableData = '<table><tbody>';
      this.tableData += '<tr>';
      this.tableData += '<td>公历</td>';
      this.tableData += '<td>'+solar.getYear()+'年</td>';
      this.tableData += '<td>'+solar.getMonth()+'月</td>';
      this.tableData += '<td>'+solar.getDay()+'日</td>';
      this.tableData += '<td>'+lunar.getTimeZhi()+'时</td>';
      this.tableData += '</tr>';
      this.tableData += '<tr>';
      this.tableData += '<td>天干</td>';
      this.tableData += '<td>'+bazi.getYearShiShenGan()+'</td>';
      this.tableData += '<td>'+bazi.getMonthShiShenGan()+'</td>';
      this.tableData += '<td>'+bazi.getDayShiShenGan()+'</td>';
      this.tableData += '<td>'+bazi.getTimeShiShenGan()+'</td>';
      this.tableData += '</tr>';
      this.tableData += '<tr>';
      this.tableData += '<td>八字</td>';
      this.tableData += '<td>'+bazi.getYear()+'</td>';
      this.tableData += '<td>'+bazi.getMonth()+'</td>';
      this.tableData += '<td>'+bazi.getDay()+'</td>';
      this.tableData += '<td>'+bazi.getTime()+'</td>';
      this.tableData += '</tr>';
      this.tableData += '<tr>';
      this.tableData += '<td>地支</td>';
      this.tableData += '<td>'+bazi.getYearShiShenZhi()[0]+'</td>';
      this.tableData += '<td>'+bazi.getMonthShiShenZhi()[0]+'</td>';
      this.tableData += '<td>'+bazi.getDayShiShenZhi()[0]+'</td>';
      this.tableData += '<td>'+bazi.getTimeShiShenZhi()[0]+'</td>';
      this.tableData += '</tr>';
      this.tableData += '<tr>';
      this.tableData += '<td>五行</td>';
      this.tableData += '<td>'+bazi.getYearWuXing()+'</td>';
      this.tableData += '<td>'+bazi.getMonthWuXing()+'</td>';
      this.tableData += '<td>'+bazi.getDayWuXing()+'</td>';
      this.tableData += '<td>'+bazi.getTimeWuXing()+'</td>';
      this.tableData += '</tr>';
      this.tableData += '<tr>';
      this.tableData += '<td>纳音</td>';
      this.tableData += '<td>'+bazi.getYearNaYin()+'</td>';
      this.tableData += '<td>'+bazi.getMonthNaYin()+'</td>';
      this.tableData += '<td>'+bazi.getDayNaYin()+'</td>';
      this.tableData += '<td>'+bazi.getTimeNaYin()+'</td>';
      this.tableData += '</tr>';
      this.tableData += '<tr>';
      this.tableData += '<td>地势</td>';
      this.tableData += '<td>'+bazi.getYearDiShi()+'</td>';
      this.tableData += '<td>'+bazi.getMonthDiShi()+'</td>';
      this.tableData += '<td>'+bazi.getDayDiShi()+'</td>';
      this.tableData += '<td>'+bazi.getTimeDiShi()+'</td>';
      this.tableData += '</tr>';
      this.tableData += '</tbody></table>'
      this.wuxing = bazi.getYearWuXing() + bazi.getMonthWuXing() + bazi.getDayWuXing() + bazi.getTimeWuXing()
      this.taiYuan =  bazi.getTaiYuan()
      this.taiYuan2 = bazi.getTaiYuanNaYin()
      this.taiXi = bazi.getTaiXi()
      this.taiXi2 = bazi.getTaiXiNaYin()
      this.mingGong = bazi.getMingGong()
      this.mingGong2 = bazi.getMingGongNaYin()
      this.shenGong = bazi.getShenGong()
      this.shenGong2 = bazi.getShenGongNaYin()
      this.dayXunKong = bazi.getDayXunKong()
      const s = Solar.fromDate(this.formatterDate(dateTime));
      const d = s.getLunar();
      this.main.a = d.getYearInGanZhi() + '年 属' + d.getYearShengXiao() + ' ' + d.getYearNaYin()
      this.main.a1 = d.getMonthInGanZhi() + '月 属' + d.getMonthShengXiao() + ' ' + d.getMonthNaYin()
      this.main.a2 = d.getDayInGanZhi() + '日 属' + d.getDayShengXiao() + ' ' + d.getDayNaYin()
      this.main.a3 = s.getJulianDay()
      this.main.b = d.getYearInChinese() + '年 ' + d.getMonthInChinese() + '月 ' + d.getDayInChinese() + ' (阴历)'
      this.main.c = s.getYear() + '年 ' + s.getMonth() + '月 ' + s.getDay() + '日 星期' + s.getWeekInChinese() + ' ' + s.getXingZuo() + '座 (阳历)'
      this.main.s1 = d.getTimeGan()
      if(this.main.s1 === '戊' || this.main.s1 === '己'){
        this.main.s2 = '土'
      }else if(this.main.s1 === '庚' || this.main.s1 === '辛'){
        this.main.s2 = '金'
      }else if(this.main.s1 === '壬' || this.main.s1 === '癸'){
        this.main.s2 = '水'
      }else if(this.main.s1 === '甲' || this.main.s1 === '乙'){
        this.main.s2 = '木'
      }else if(this.main.s1 === '丙' || this.main.s1 === '丁'){
        this.main.s2 = '火'
      }
      this.main.s3 = d.getTimeZhi()
      if(this.main.s3 === '丑' || this.main.s3 === '戌' || this.main.s3 === '未' || this.main.s3 === '辰'){
        this.main.s4 = '土'
      }else if(this.main.s3 === '申' || this.main.s3 === '酉'){
        this.main.s4 = '金'
      }else if(this.main.s3 === '子' || this.main.s3 === '亥'){
        this.main.s4 = '水'
      }else if(this.main.s3 === '寅' || this.main.s3 === '卯'){
        this.main.s4 = '木'
      }else if(this.main.s3 === '巳' || this.main.s3 === '午'){
        this.main.s4 = '火'
      }
      let quewx = ''
      if(this.wuxing.indexOf('金') === -1){
        quewx += '金'
      }
      if(this.wuxing.indexOf('木') === -1){
        quewx += '木'
      }
      if(this.wuxing.indexOf('水') === -1){
        quewx += '水'
      }
      if(this.wuxing.indexOf('火') === -1){
        quewx += '火'
      }
      if(this.wuxing.indexOf('土') === -1){
        quewx += '土'
      }
      this.quewx = quewx === '' ? '当前时辰五行不缺' : '当前时辰五行缺' + quewx
    },
    formatterDate (date) {
      let result = new Date(date);
      return result;
    },
    getListData() {
      if(this.name === ''){
        this.$message.warning('请输入姓氏！')
        return
      }
      const name = surname.data.filter(item=>item.name === this.name)
      if(name.length > 0){
        this.wx = this.name + (name[0].wx.length === 1 ? '姓，五行属' : '姓，五行') + name[0].wx
        this.creatName()
        this.nameVisible = true
        this.bodyVisible = true
      }else{
        this.wx = ''
        this.bodyVisible = false
      }
      this.loading = true
      this.$axios({
        url: this.apiUrl + "baijiaxing/list.php",
        method: "post",
        params: {
          title: this.name,
          pageNumber: 1
        }
      })
        .then(res => {
          this.listData = [];
          if (res.data.code == 10000) {
            const data = res.data.data
            data.filter(item=>item.post_title === this.name)
            if(data.length > 0){
              this.body = data[0].post_content
            }
          }else{
            this.body = '历史来源<p>' + (name.length > 0 ? name[0].source : '') + '</p>'
          }
          this.loading = false
        })
        .catch(err => {
          this.$message.error('服务器出错，请稍后再试！')
        });
    },
    htmlFormat(value) {
      if (!value) return "";
      value = value.replace(/<p[^>]*?><img[^>]*?><\/p>/g, "").replace(/<br>/g, '</p><p>').replace(/<p><\/p>/g, "").replace(/源出;<\/p>/g, "源出<\/p>").replace(/一 ;/g, "一、").replace(/二 ;/g, "二、").replace(/三 ;/g, "三、").replace(/四 ;/g, "四、").replace(/五 ;/g, "五、").replace(/六 ;/g, "六、").replace(/七 ;/g, "七、").replace(/八 ;/g, "八、").replace(/九 ;/g, "九、").replace(/十 ;/g, "十、").replace(/历史来源/g, "<h3>历史来源<\/h3>").replace(/家族名人/g, "<h3>家族名人<\/h3>").replace(/地望分布/g, "<h3>地望分布<\/h3>").replace(/迁徙分布/g, "<h3>迁徙分布<\/h3>");
      return value;
    },
    creatName(){
      let quewx = this.quewx !== '' && this.quewx !== '当前时辰五行不缺' ? this.quewx.replace('当前时辰五行缺', '').replace(/[`:_.~!@#$%^&*() \+ =<>?"{}|, \/ ;' \\ [ \] ·~！@#￥%……&*（）—— \+ ={}|《》？：“”【】、；‘’，。、]/g,'') : ''
      // console.log('quewx',quewx)
      let quewxA = quewx.split('')
      let nameData = []
      if(quewxA.length === 0){
        nameData = this.nameDataArr
      }else if(quewxA.length === 1){
        const nameData1 = this.nameDataArr.filter(item =>item.wx1.indexOf(quewxA[0]) !== -1)
        const nameData2 = this.nameDataArr.filter(item =>item.wx2.indexOf(quewxA[0]) !== -1)
        nameData = nameData1.concat(nameData2)
      }else if(quewxA.length >= 2){
        const nameData1 = this.nameDataArr.filter(item =>item.wx1.indexOf(quewxA[0]) !== -1 && item.wx2.indexOf(quewxA[1]) !== -1)
        const nameData2 = this.nameDataArr.filter(item =>item.wx2.indexOf(quewxA[0]) !== -1 && item.wx1.indexOf(quewxA[1]) !== -1)
        nameData = nameData1.concat(nameData2)
      }
      let nameData2 = []
      nameData.forEach(item =>{
        if(item.type === 2){
          nameData2.push(item)
        }
      })
      const totalItems = nameData2.length;  
      const randomIndices = [];  
      while (randomIndices.length < 10) {  
        const randomIndex = Math.floor(Math.random() * totalItems);  
        if (!randomIndices.includes(randomIndex)) {  
          randomIndices.push(randomIndex);  
        }  
      }
      this.createNameData = []
      const createNameData = randomIndices.map(index => nameData2[index]); 
      createNameData.forEach(item => {
        const name = item.name.split('')
        this.createNameData.push({
          ...item,
          wx:name[0] + '字属' + item.wx1 + '，' + name[1] + '字属' + item.wx2,
          desc: item.typename !== ''  ? '出自《' + item.typename + '》：' + item.desc : item.desc
        })
      })
      this.nameDataVisible = true 
    }
  }
};
</script>
<style lang="scss" scoped>
@font-face {
  font-family: "JingHuaLaoSongTi";
  font-weight: normal;
  src: url("../assets/aliyun/8m2D40dU62JY.woff2") format("woff2"),
  url("../assets/aliyun/8m2D40dU62JY.woff") format("woff");
  font-display: swap;
  font-style: normal;
}
.calendar * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.calendar {
  .container {
    width: 100%;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,.08);
    border-radius: 15px;
    margin: 0 0 15px;
    box-sizing: border-box;
    // border: 2px solid #4E6EF2;
    overflow: hidden;
    .c-header {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 55px;
      padding: 12px;
      background: #eaecf2;
      overflow: hidden;
      ol{
        display: flex;
        align-items: center;
        li{
          display: flex;
          align-items: center;
          position: relative;
          margin-right: 10px;
          width: 240px;
          &:nth-child(3){
            position: absolute;
            right: 20px;
            width: auto;
            font-size: 18px;
            font-weight: bold;
            color: #f00;
          }
          i{
            color: #888;
            font-size: 16px;
            cursor: pointer;
            margin: 0 3px;
            &:hover{
              color: #333;
            }
          }
          .el-button{
            width: 80px;
            height: 29px;
          }
        }
      }
      .button{
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #fff;
        border-radius: 6px;
        color: #333;
        cursor: pointer;
        font-size: 13px;
        padding: 0 12px;
        margin-left: 12px;
        &:hover{
          color: #0f9fff;
          opacity: .75;
        }
      }
    }
    p{
      text-align: center;
      color: #999;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      padding: 40px;
    }
  }
}
.name-box{
  display: flex;
}
.almanac-table{
  border: 1px solid #ddd;
  width: 75%;
  border-spacing: 0;
  border-collapse: collapse;
  border-radius: 15px;
  table-layout:fixed;
  margin-top: 15px;
  font-size: 16px;
}
 .table-li{
    width: 25%;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,.08);
    border-radius: 15px;
    box-sizing: border-box;
    border: 1px solid #ddd;
    margin-top: 15px;
    margin-left: 15px;
    font-size: 16px;
    overflow: hidden;
    li{
      display: flex;
      width: 100%;
      float: left;
      border-left: 1px solid #ddd;
      border-top: 1px solid #ddd;
      padding: 5px 8px 6px;
      align-items: center;
      box-sizing: border-box;
      &:last-child{
        height: 62px;
        justify-content: center;
        font-size: 18px;
        background: #f00;
        color: #fff;
      }
      label{
        display: inline-block;
        background: #eaecf2;
        width: 80px;
        height: 26px;
        line-height: 26px;
        text-align: right;
        margin-right: 10px;
        border-radius: 3px;
        flex: 0 0 auto;
      }
      span{
        display: flex;
        align-items: center;
        flex: 1 1 auto;
      }
      a{
        color: #409eff;
        &:hover{
          text-decoration: underline;
        }
      }
    }
}
.namedata{
    margin-top: 13px;
    border: 1px solid #ddd;
    overflow: hidden;
    dl{
      display: flex;
      font-size: 16px;
      border-bottom: 1px solid #ddd;
      &.dl-first{
        border-top: 1px solid #ddd;
      }
      dt{
        width: 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2px 12px;
        width: 100px;
        line-height: 35px;
        border-right: 1px solid #ddd;
        border-top: none;
        border-bottom:none;
      }
      dd{
        width: calc(100% - 100px);
        padding: 2px 12px;
        line-height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        span{
          &.green{
            color: green;
          }
          &.red{
            color: red;
            margin-left: 15px;
          }
        }
      }
      &:nth-child(2n){
        background: #f6f8f6;
      }
      dd.wx{
        width: 240px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #ddd;
      }
      &:last-child{
        border-bottom: none;
      }
    }
  }
@media screen and (max-width: 1000px) {
  .calendar .container .c-header ol li{
    width: 160px;
  }
  .calendar .container .c-header ol li:nth-child(3){
    display: none;
  }
  .c-header div.button{
    display: none!important;
  }
  .name-box{
    display: block;
  }
  .almanac-table, .table-li{
    width: 100%;
    margin-left: 0;
  }
  .calendar .body-box{
    padding:  0 0 20px!important;
  }
}
</style>
<style>
.almanac-table table{
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  margin-top: 2px;
}
.almanac-table table td{
  padding: 4px;
  height: 27px;
  border-bottom: 1px solid #ddd;
  border-left: 1px solid #ddd;
  text-align: center;
  line-height: 18px;
}
.almanac-table table td:nth-child(1){
  padding: 4px 2px;
  white-space: nowrap;
}
.almanac-table table tr td:nth-child(1){
  border-left: none;
}
.almanac-table table tr:last-child td{
  border-bottom: none;
}
.calendar .body-box {
  padding: 0 20px 20px;
  box-sizing: border-box;
  color: #333;
  overflow: hidden;
}
.calendar h3 {
  font-weight: 600;
  color: #333;
  font-size: 18px;
}
.calendar h3::before{
  content: '';
  display: inline-block;
  width: 4px;
  height: 18px;
  background: #fb5b4d;
  position: relative;
  top: 3px;
  margin-right: 12px;
}
.calendar .body-box table {
  width: 100%;
  border-left: 1px solid #eee;
  border-top: 1px solid #eee;
  color: #666;
}
.calendar .body-box table td {
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.calendar .body-box {
  word-break: break-word;
  margin-top: 0;
  color: #333;
  line-height: 27px;
  font-size: 16px;
}
.calendar .body-box p {
  word-break: break-word;
  margin-top: 0;
}
.calendar .body-box p strong{
  color: #333;
}
.calendar .body-box ul {
  background: #f0f0f0;
  box-sizing: border-box;
}
.calendar .body-box li {
  overflow: hidden;
  border-bottom: 1px solid #fff;
}
.calendar .body-box li span {
  display: inline-block;
}
.c-header .el-input__inner{
  font-size: 16px!important;
}
.pd20{
  padding: 20px 20px 0!important;
}
br{
  margin: 0;
  padding: 0;
}
@media screen and (max-width: 1000px) {
  .pd20{
    padding: 20px 0 0!important;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Name.vue